import { jsx as r } from "react/jsx-runtime";
const t = () => /* @__PURE__ */ r(
  "path",
  {
    d: "M7.62563 6.92308C7.62563 7.4328 7.23391 7.84615 6.75071 7.84615C6.2675 7.84615 5.87578 7.4328 5.87578 6.92308M7.62563 6.92308C7.62563 6.41328 7.23391 6 6.75071 6C6.2675 6 5.87578 6.41328 5.87578 6.92308M7.62563 6.92308H5.87578M18.1247 6.92308C18.1247 7.4328 17.7329 7.84615 17.2498 7.84615C16.7667 7.84615 16.3749 7.4328 16.3749 6.92308M18.1247 6.92308C18.1247 6.41328 17.7329 6 17.2498 6C16.7667 6 16.3749 6.41328 16.3749 6.92308M18.1247 6.92308H16.3749M19 18C17.4038 15.758 14.8625 14.3077 12.0001 14.3077C9.13768 14.3077 6.59623 15.758 5 18",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
);
export {
  t as default
};
